import { Form } from "react-bootstrap";
import { Campo } from "../../services/tipos";
import { TipoFormulario } from "../../services/constantes";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import React from "react";

interface InputPasswordProps {
  campo: Campo;
  modo: TipoFormulario;
  getFieldValue: (campoNome: string) => string;
  handleInputChange: (nome: string, value: string) => void;
}

export function InputPassword(props: InputPasswordProps) {
  const [mostrarSenha, setMostrarSenha] = React.useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    props.handleInputChange(props.campo.nome, value);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
      <Form.Control
        type={mostrarSenha ? "text" : "password"}
        readOnly={props.modo === TipoFormulario.tpVisualizacao}
        required={props.campo.required}
        value={props.getFieldValue(props.campo.nome)}
        onChange={handleInputChange}
        maxLength={props.campo.maximoCaracteres || 100}
        minLength={props.campo.minimoCaracteres || 0}
        className="custom-text-input"
        style={{ paddingRight: "2rem" }} // Garante espaço para o ícone
      />
      <span
        onClick={() => setMostrarSenha(!mostrarSenha)}
        style={{
          position: "absolute",
          right: "0.5rem",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#6c757d",
          display: "flex",
          alignItems: "center",
        }}
        title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
      >
        {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>
  );
}
